import {
  ADMIN_EXAM_CENTER,
  ADMIN_EXAM_CENTER_MEMBER,
  ADMIN_EXAM_CENTER_EXAM_COURSE,
  ADMIN_EXAM_COURSE_SETTINGS,
  ADMIN_EXAM_ASSIGNING,
  ADMIN_AVAILABLE_QSETS,
  ADMIN_BLOCKED_USER,
  ADMIN_PROCTOR,
  ADMIN_PROCTOR_REQUEST,
  ADMIN_PROCTOR_REQUEST_FIRST_TIER_REVIEW,
  ADMIN_PROCTOR_REQUEST_SECOND_TIER_REVIEW,
  ADMIN_PROCTOR_EXPIRATION,
  ADMIN_EXAM_LOCATION,
  ADMIN_EXAM_LOCATION_REQUEST,
  ADMIN_EXAM_LOCATION_REQUEST_FIRST_TIER_REVIEW,
  ADMIN_QUESTIONNAIRE_REPORT,
  PROCTOR,
  PROCTOR_REQUEST,
  PROCTOR_EXPIRATION,
  ADMIN_EXAM_LOCATION_CANCELATION,
  ADMIN_EXAM_LOCATION_REQUEST_SECOND_TIER_REVIEW,
  EXAM_LOCATION_REQUEST,
  EXAM_LOCATION,
  ADMIN_EXAM_LOCATION_USAGE,
  EXAM_LOCATION_CANCELATION,
  EXAM_CENTER,
  EXAM_CENTER_MEMBER,
  EXAM_CENTER_EXAM_COURSE,
  EXAM_EVENT_RESULTS,
  EXAM_EVENT_EXAMINEES,
  EXAM_EVENT,
  PROCTORING,
  PROCTORING_EKYC,
  PROCTORING_REGISTRATION,
  ADMIN_WEB_REGISTER_ANNOUNCEMENT,
  ADMIN_PROCTOR_AUDIT_LOG,
  EXAM_EVENT_AUDIT_LOG,
  ADMIN_EXAM_LOCATION_AUDIT_LOG,
  ADMIN_SET_PORTAL_EXAM_RESULT_FILE,
} from '@shared/permissions';

const APP_PERMISSIONS = {
  ADMIN_EXAM_CENTER_MANAGEMENT: {
    EXAM_CENTER: ADMIN_EXAM_CENTER,
    MEMBER: ADMIN_EXAM_CENTER_MEMBER,
    EXAM_COURSE: ADMIN_EXAM_CENTER_EXAM_COURSE,
  },
  ADMIN_ANNOUNCEMENT_MANAGEMENT: {
    WEB_REGISTER_ANNOUNCEMENT: ADMIN_WEB_REGISTER_ANNOUNCEMENT,
  },
  ADMIN_EXAM_COURSE_MANAGEMENT: {
    SETTINGS: ADMIN_EXAM_COURSE_SETTINGS,
  },
  ADMIN_EXAM_DISTRIBUTION: {
    EXAM_ASSIGNING: ADMIN_EXAM_ASSIGNING,
    AVAILABLE_QSETS: ADMIN_AVAILABLE_QSETS,
  },
  ADMIN_BLOCKLIST_MANAGEMENT: {
    BLOCKED_USER: ADMIN_BLOCKED_USER,
  },
  ADMIN_PROCTOR_MANAGEMENT: {
    PROCTOR: ADMIN_PROCTOR,
    PROCTOR_REQUEST: ADMIN_PROCTOR_REQUEST,
    PROCTOR_REQUEST_FIRST_TIER_REVIEW: ADMIN_PROCTOR_REQUEST_FIRST_TIER_REVIEW,
    PROCTOR_REQUEST_SECOND_TIER_REVIEW: ADMIN_PROCTOR_REQUEST_SECOND_TIER_REVIEW,
    PROCTOR_EXPIRATION: ADMIN_PROCTOR_EXPIRATION,
    AUDIT_LOG: ADMIN_PROCTOR_AUDIT_LOG,
  },
  ADMIN_EXAM_LOCATION_MANAGEMENT: {
    EXAM_LOCATION: ADMIN_EXAM_LOCATION,
    EXAM_LOCATION_USAGE: ADMIN_EXAM_LOCATION_USAGE,
    EXAM_LOCATION_REQUEST: ADMIN_EXAM_LOCATION_REQUEST,
    EXAM_LOCATION_REQUEST_FIRST_TIER_REVIEW: ADMIN_EXAM_LOCATION_REQUEST_FIRST_TIER_REVIEW,
    EXAM_LOCATION_REQUEST_SECOND_TIER_REVIEW: ADMIN_EXAM_LOCATION_REQUEST_SECOND_TIER_REVIEW,
    EXAM_LOCATION_CANCELATION: ADMIN_EXAM_LOCATION_CANCELATION,
    AUDIT_LOG: ADMIN_EXAM_LOCATION_AUDIT_LOG,
  },
  ADMIN_QUESTIONNAIRE_MANAGEMENT: {
    QUESTIONNAIRE_REPORT: ADMIN_QUESTIONNAIRE_REPORT,
  },
  ADMIN_SET_PORTAL_MANAGEMENT: {
    EXAM_RESULT_FILE: ADMIN_SET_PORTAL_EXAM_RESULT_FILE,
  },
  EXAM_CENTER_MANAGEMENT: {
    EXAM_CENTER,
    MEMBER: EXAM_CENTER_MEMBER,
    EXAM_COURSE: EXAM_CENTER_EXAM_COURSE,
  },
  EXAM_EVENT_MANAGEMENT: {
    EXAM_EVENT,
    EXAMINEES: EXAM_EVENT_EXAMINEES,
    RESULTS: EXAM_EVENT_RESULTS,
    AUDIT_LOG: EXAM_EVENT_AUDIT_LOG,
  },
  PROCTORING: {
    DETAILS: PROCTORING,
    REGISTRATION: PROCTORING_REGISTRATION,
    E_KYC: PROCTORING_EKYC,
  },
  PROCTOR_MANAGEMENT: {
    PROCTOR,
    PROCTOR_REQUEST,
    PROCTOR_EXPIRATION,
  },
  EXAM_LOCATION_MANAGEMENT: {
    EXAM_LOCATION,
    EXAM_LOCATION_REQUEST,
    EXAM_LOCATION_CANCELATION,
  },
};

export { APP_PERMISSIONS };
